(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["low-stock-fomo"] && !Shopify.designMode) return;
  try {
    (function () {
    function update(variantId, root) {
      var scope = root || document;
      scope.querySelectorAll('[data-gw-fomo]').forEach(function (el) {
        var data = document.querySelector('[data-gw-fomo-stock="' + el.dataset.productId + '"]');
        if (!data) return;
        var stock;
        try { stock = JSON.parse(data.textContent); } catch (e) { return; }
        if (!(String(variantId) in stock)) return;
        var qty = stock[String(variantId)];
        var threshold = parseInt(el.dataset.threshold, 10) || 10;
        var show = qty !== null && qty > 0 && qty < threshold;
        el.hidden = !show;
        if (!show) return;
        var msg = el.querySelector('[data-gw-fomo-msg]');
        if (msg) msg.textContent = msg.dataset.template.replace(/\[count\]/g, qty);
        el.style.setProperty('--gw-fill', Math.max(8, Math.round((qty / threshold) * 100)) + '%');
      });
    }

    // Horizon feuert "variant:update" beim Variantenwechsel
    document.addEventListener('variant:update', function (event) {
      var d = event.detail || {};
      var variant = d.resource || (d.data && d.data.variant) || d.variant;
      if (variant && variant.id) update(variant.id);
    });

    // Fallback: Varianten-ID aus dem Formular / der URL lesen
    document.addEventListener('change', function (event) {
      var form = event.target.closest('form');
      if (!form) return;
      var input = form.querySelector('input[name="id"]');
      if (input && input.value) setTimeout(function () { update(input.value); }, 50);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["preorder-notice"] && !Shopify.designMode) return;
  try {
    (function () {
    function fmt(d) {
      var dd = String(d.getDate()).padStart(2, '0');
      var mm = String(d.getMonth() + 1).padStart(2, '0');
      return dd + '.' + mm + '.' + d.getFullYear();
    }

    // Datum im Browser neu berechnen (Seiten-Cache würde sonst alte Daten zeigen)
    function refreshDates(root) {
      (root || document).querySelectorAll('[data-gw-preorder]').forEach(function (el) {
        var line = el.querySelector('[data-gw-preorder-dates]');
        if (!line) return;
        var minW = parseInt(el.dataset.minWeeks, 10) || 4;
        var maxW = parseInt(el.dataset.maxWeeks, 10) || 6;
        var now = new Date();
        var from = new Date(now.getTime() + minW * 7 * 864e5);
        var to = new Date(now.getTime() + maxW * 7 * 864e5);
        line.textContent = line.dataset.template.replace(/\[from\]/g, fmt(from)).replace(/\[to\]/g, fmt(to));
      });
    }

    function update(variantId) {
      document.querySelectorAll('[data-gw-preorder]').forEach(function (el) {
        var data = document.querySelector('[data-gw-preorder-stock="' + el.dataset.productId + '"]');
        if (!data) return;
        var map;
        try { map = JSON.parse(data.textContent); } catch (e) { return; }
        if (!(String(variantId) in map)) return;
        var show = map[String(variantId)] === true;
        el.hidden = !show;
        var prop = el.querySelector('[data-gw-preorder-property]');
        if (prop) prop.disabled = !show;
      });
    }

    refreshDates();
    document.addEventListener('DOMContentLoaded', function () { refreshDates(); });

    // Horizon feuert "variant:update" beim Variantenwechsel
    document.addEventListener('variant:update', function (event) {
      var d = event.detail || {};
      var variant = d.resource || (d.data && d.data.variant) || d.variant;
      if (variant && variant.id) update(variant.id);
      setTimeout(function () { refreshDates(); }, 60);
    });

    // Fallback: Varianten-ID aus dem Formular lesen
    document.addEventListener('change', function (event) {
      var form = event.target.closest('form');
      if (!form) return;
      var input = form.querySelector('input[name="id"]');
      if (input && input.value) setTimeout(function () { update(input.value); }, 50);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["set-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__gwUpsellBound) return;
    window.__gwUpsellBound = true;

    // Größenwechsel (36-40 / 41-45) -> passende Sets live einblenden
    function applySize(sizeText) {
      var g = /41-45/.test(sizeText) ? 'Herren' : (/36-40/.test(sizeText) ? 'Damen' : '');
      document.querySelectorAll('[data-gw-upsell]').forEach(function (w) {
        var max = parseInt(w.dataset.max, 10) || 2;
        var n = 0;
        w.querySelectorAll('.gw-upsell__card').forEach(function (c) {
          var ok = n < max && (!g || c.dataset.group === 'all' || c.dataset.group === g);
          c.hidden = !ok;
          if (ok) n++;
        });
        w.hidden = n === 0;
      });
    }
    document.addEventListener('variant:update', function (event) {
      var d = event.detail || {};
      var v = d.resource || (d.data && d.data.variant) || d.variant;
      if (v) applySize([v.title, v.option1, (v.options || []).join(' ')].join(' '));
    });
    document.addEventListener('change', function (event) {
      var t = event.target;
      if (t && typeof t.value === 'string' && /^(36-40|41-45)$/.test(t.value)) applySize(t.value);
    });

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    async function addSet(btn) {
      var wrap = btn.closest('[data-gw-upsell]');
      var label = btn.querySelector('[data-gw-upsell-label]');
      var original = label ? label.textContent : '';
      btn.disabled = true;
      if (label && wrap) label.textContent = wrap.dataset.txtAdding;

      var item = { id: Number(btn.dataset.variantId), quantity: 1 };
      if (btn.dataset.propName) {
        item.properties = {};
        item.properties[btn.dataset.propName] = btn.dataset.propValue;
      }

      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) {
        if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });

      var events = null;
      try { events = await import('@shopify/events'); } catch (e) { events = null; }

      var deferred = null;
      if (events && events.CartLinesUpdateEvent) {
        deferred = events.CartLinesUpdateEvent.createPromise();
        btn.dispatchEvent(new events.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(item.id), quantity: 1 }],
          promise: deferred.promise
        }));
      }

      try {
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item], sections: sectionIds.join(',') })
        });
        var data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'error');

        var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();

        if (deferred) {
          deferred.resolve({
            cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              source: 'gw-set-upsell',
              sourceId: 'gw-set-upsell',
              itemCount: 1,
              productId: btn.dataset.productId,
              sections: data.sections,
              didError: false
            }
          });
        } else {
          window.location.href = root + 'cart';
          return;
        }

        if (label && wrap) label.textContent = wrap.dataset.txtAdded;
        setTimeout(function () { if (label) label.textContent = original; btn.disabled = false; }, 2200);
      } catch (err) {
        console.error(err);
        if (deferred) deferred.reject(err);
        if (label && wrap) label.textContent = wrap.dataset.txtError;
        setTimeout(function () { if (label) label.textContent = original; btn.disabled = false; }, 2500);
      }
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-gw-upsell-add]');
      if (!btn || btn.disabled) return;
      event.preventDefault();
      addSet(btn);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
